import { formatUsdWithCents } from "../gacha-data"
export {
  deriveBuybackRatePercent,
  formatBuybackRatePercent,
} from "../gacha-buyback-rate"

export const GACHA_BUYBACK_WINDOW_MS = 72 * 60 * 60 * 1000

export function isGachaBuybackEligible(
  pulledAtMs: number,
  nowMs: number = Date.now(),
): boolean {
  return nowMs - pulledAtMs < GACHA_BUYBACK_WINDOW_MS
}

export function formatUsdBuyback(amount: number): string {
  return formatUsdWithCents(amount)
}

export function deriveBuybackOfferFromMarketValue(
  price: string,
  buybackPercent: number,
): string {
  const marketValue = Number(price.replace(/[$,]/g, "")) || 0
  return formatUsdBuyback((marketValue * buybackPercent) / 100)
}

export function getGachaBuybackDeadlineMs(pulledAtMs: number): number {
  return pulledAtMs + GACHA_BUYBACK_WINDOW_MS
}

export function formatGachaBuybackCountdown(
  deadlineMs: number,
  nowMs: number = Date.now(),
): string {
  const remaining = deadlineMs - nowMs

  if (remaining <= 0) {
    return "Expired"
  }

  const totalSec = Math.floor(remaining / 1000)
  const days = Math.floor(totalSec / 86400)
  const hours = Math.floor((totalSec % 86400) / 3600)
  const minutes = Math.floor((totalSec % 3600) / 60)
  const seconds = totalSec % 60

  if (days > 0) {
    return `${days}d ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
}
